
import React from 'react';
import { FormField, FormControl, FormItem } from "./form";
import { Input } from "./input";
import { UseFormReturn } from "react-hook-form";

/**
 * A hidden form field that helps detect and prevent spam submissions.
 * This field should be invisible to human users but will be filled by bots.
 * If the field contains any value, the submission should be rejected.
 */
export const HoneypotField = ({ form }: { form: UseFormReturn<any> }) => {
  return (
    <FormField
      control={form.control}
      name="website"
      render={({ field }) => (
        <FormItem className="sr-only" aria-hidden="true" style={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: '0',
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          borderWidth: '0',
        }}>
          <FormControl>
            <Input
              tabIndex={-1}
              autoComplete="off"
              {...field}
              placeholder="Please leave this empty"
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};

/**
 * Helper function to validate honeypot field
 * @returns true if the submission is legitimate (honeypot empty)
 */
export const validateHoneypot = (data: any): boolean => {
  // Check if the honeypot field is empty or undefined
  return !data.website;
};
